export default __webpack_public_path__ + "static/media/img6.4df6772d.jpg";